export enum KnownMimeTypes {
  FormData = 'multipart/form-data',
  Json = 'application/json',
  Xml = 'text/xml',
  UrlEncodedForm = 'application/x-www-form-urlencoded',
}
